/* ===== FENLYX magic engine ===== */
(function(){
'use strict';
var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
var fmt = function(n){return '$'+Math.round(n).toLocaleString('en-US');};

/* ---------- Lenis smooth scroll ---------- */
var lenis=null;
if(window.Lenis && !RM){
  lenis=new window.Lenis({lerp:.09,wheelMultiplier:1});
  window.lenis=lenis;
  function raf(t){lenis.raf(t);requestAnimationFrame(raf);}
  requestAnimationFrame(raf);
  if(window.gsap && window.ScrollTrigger){
    lenis.on('scroll',window.ScrollTrigger.update);
    window.gsap.ticker.add(function(t){lenis.raf(t*1000);});
    window.gsap.ticker.lagSmoothing(0);
  }
}

/* ---------- value-stream canvas ---------- */
(function(){
  var cv=document.getElementById('flow'); if(!cv||RM) return;
  var ctx=cv.getContext('2d'),W,H,DPR=Math.min(devicePixelRatio||1,2),ps=[];
  function size(){W=cv.width=innerWidth*DPR;H=cv.height=innerHeight*DPR;cv.style.width=innerWidth+'px';cv.style.height=innerHeight+'px';}
  size();addEventListener('resize',size);
  var N=Math.min(90,Math.floor(innerWidth/16));
  for(var i=0;i<N;i++)ps.push({x:Math.random()*W,y:Math.random()*H,r:(Math.random()*1.5+.4)*DPR,
    v:(Math.random()*.4+.15)*DPR,d:Math.random()*.5-.25,a:Math.random()*.5+.2,t:Math.random()*100});
  function draw(){
    ctx.clearRect(0,0,W,H);
    for(var i=0;i<ps.length;i++){var p=ps[i];p.y-=p.v;p.x+=p.d+Math.sin((p.t+=.01))*.15*DPR;
      if(p.y<-10){p.y=H+10;p.x=Math.random()*W;}
      ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.283);
      ctx.fillStyle='rgba(245,179,1,'+(p.a*.5)+')';ctx.fill();
    }
    requestAnimationFrame(draw);
  }
  draw();
})();

/* ---------- gold cursor glow ---------- */
(function(){
  var g=document.querySelector('.glow'); if(!g) return;
  var x=innerWidth/2,y=innerHeight/2,cx=x,cy=y;
  addEventListener('mousemove',function(e){x=e.clientX;y=e.clientY;});
  (function loop(){cx+=(x-cx)*.12;cy+=(y-cy)*.12;g.style.transform='translate('+cx+'px,'+cy+'px)';requestAnimationFrame(loop);})();
})();

/* ---------- hero statement countdown + coins ---------- */
(function(){
  var stmt=document.getElementById('stmt'); if(!stmt) return;
  var rows=[].slice.call(stmt.querySelectorAll('.srow')),
      tot=stmt.querySelector('.stmt__t .now'), totFrom=+tot.getAttribute('data-from'), totTo=+tot.getAttribute('data-to'),
      saveEl=stmt.querySelector('.stmt__save'), played=false, cv=document.getElementById('hero-canvas');
  var ctx=cv?cv.getContext('2d'):null,DPR=Math.min(devicePixelRatio||1,2),coins=[],W,H;
  function size(){if(!cv)return;W=cv.width=cv.offsetWidth*DPR;H=cv.height=cv.offsetHeight*DPR;}
  if(cv){size();addEventListener('resize',size);}
  function coinLoop(){
    if(!ctx)return;ctx.clearRect(0,0,W,H);var alive=false;
    for(var i=0;i<coins.length;i++){var c=coins[i];if(c.life<=0)continue;alive=true;
      c.vy+=.05*DPR;c.x+=c.vx;c.y+=c.vy;c.life--;
      ctx.beginPath();ctx.arc(c.x,c.y,c.r,0,6.283);
      ctx.fillStyle='rgba(255,'+(180+Math.random()*40|0)+',60,'+Math.min(1,c.life/40)+')';ctx.fill();
    }
    if(alive)requestAnimationFrame(coinLoop);
  }
  function burst(){
    if(!cv)return;var tr=tot.getBoundingClientRect(),cr=cv.getBoundingClientRect(),
      sx=(tr.left-cr.left+tr.width/2)*DPR, sy=(tr.top-cr.top+tr.height/2)*DPR;
    for(var i=0;i<46;i++)coins.push({x:sx,y:sy,vx:(Math.random()*6-3)*DPR,vy:(Math.random()*-5-2)*DPR,
      r:(Math.random()*2.4+1.2)*DPR,life:40+Math.random()*40});
    coinLoop();
  }
  function tween(node,from,to,ms,cb){
    var t0=null;
    function step(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/ms),e=1-Math.pow(1-k,3);
      node.textContent=fmt(from+(to-from)*e);if(k<1)requestAnimationFrame(step);else if(cb)cb();}
    requestAnimationFrame(step);
  }
  function play(){
    if(played)return;played=true;
    rows.forEach(function(r,i){
      var now=r.querySelector('.now'),f=+now.getAttribute('data-from'),tt=+now.getAttribute('data-to');
      setTimeout(function(){
        r.querySelector('.was').style.opacity=1;
        tween(now,f,tt,700,function(){r.classList.remove('dim');});
      },350+i*430);
    });
    setTimeout(function(){
      tween(tot,totFrom,totTo,1100,function(){
        if(saveEl){saveEl.style.transition='opacity .6s,transform .6s';saveEl.style.opacity=1;saveEl.style.transform='translateY(0)';}
        burst();
      });
    },350+rows.length*430+150);
  }
  if(saveEl){saveEl.style.opacity=0;saveEl.style.transform='translateY(12px)';}
  if(RM){ // no motion: show final state
    rows.forEach(function(r){var now=r.querySelector('.now');now.textContent=fmt(+now.getAttribute('data-to'));r.classList.remove('dim');});
    tot.textContent=fmt(totTo);if(saveEl){saveEl.style.opacity=1;saveEl.style.transform='none';}
    return;
  }
  // init dim state
  rows.forEach(function(r){r.classList.add('dim');r.querySelector('.was').style.opacity=.55;
    var now=r.querySelector('.now');now.textContent=fmt(+now.getAttribute('data-from'));});
  tot.textContent=fmt(totFrom);
  if(window.IntersectionObserver){
    new IntersectionObserver(function(en,o){en.forEach(function(e){if(e.isIntersecting){play();o.disconnect();}});},{threshold:.4}).observe(stmt);
  } else setTimeout(play,600);
})();

/* ---------- savings gauges ---------- */
(function(){
  var gs=[].slice.call(document.querySelectorAll('.gauge'));
  gs.forEach(function(g){
    var num=g.querySelector('b'),pct=+g.getAttribute('data-pct');
    function run(){
      g.classList.add('live');
      if(RM){num.innerHTML=pct+'<em>%</em>';return;}
      var t0=null;
      function step(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/1400),e=1-Math.pow(1-k,3);
        num.innerHTML=Math.round(pct*e)+'<em>%</em>';if(k<1)requestAnimationFrame(step);}
      requestAnimationFrame(step);
    }
    if(window.IntersectionObserver){
      new IntersectionObserver(function(en,o){en.forEach(function(e){if(e.isIntersecting){run();o.disconnect();}});},{threshold:.4}).observe(g);
    } else run();
  });
})();

/* ---------- count-ups ---------- */
(function(){
  var els=[].slice.call(document.querySelectorAll('[data-count]'));
  els.forEach(function(el){
    var to=parseFloat(el.getAttribute('data-count')),dec=(to%1!==0),done=false;
    function run(){if(done)return;done=true;if(RM){el.textContent=dec?to.toFixed(1):to;return;}
      var t0=null;function step(t){if(!t0)t0=t;var k=Math.min(1,(t-t0)/1500),e=1-Math.pow(1-k,3),v=to*e;
        el.textContent=dec?v.toFixed(1):Math.round(v);if(k<1)requestAnimationFrame(step);}requestAnimationFrame(step);}
    if(window.IntersectionObserver){new IntersectionObserver(function(en,o){en.forEach(function(e){if(e.isIntersecting){run();o.disconnect();}});},{threshold:.5}).observe(el);}else run();
  });
})();

/* ---------- GSAP reveals + scroll ---------- */
if(window.gsap && window.ScrollTrigger && !RM){
  var gsap=window.gsap;gsap.registerPlugin(window.ScrollTrigger);
  gsap.utils.toArray('[data-rv]').forEach(function(el){
    gsap.to(el,{opacity:1,y:0,duration:.9,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 86%'}});
  });
  gsap.utils.toArray('[data-stagger]').forEach(function(box){
    gsap.to(box.children,{opacity:1,y:0,duration:.8,ease:'power3.out',stagger:.09,scrollTrigger:{trigger:box,start:'top 82%'}});
  });
  gsap.utils.toArray('.stat').forEach(function(s){
    window.ScrollTrigger.create({trigger:s,start:'top 82%',onEnter:function(){s.classList.add('live');}});
  });
  // process bus fill
  var bus=document.querySelector('.bus');
  if(bus){var fill=bus.querySelector('.bus__fill'),dot=bus.querySelector('.bus__dot');
    window.ScrollTrigger.create({trigger:'.steps',start:'top 70%',end:'bottom 60%',scrub:.6,
      onUpdate:function(st){var p=st.progress;fill.style.transform='scaleX('+p+')';dot.style.left=(p*100)+'%';}});
  }
  // savings HUD fill on scroll + running $
  var shud=document.querySelector('.shud'),bar=shud&&shud.querySelector('.shud__bar i'),num=shud&&shud.querySelector('b'),
      target=shud?+shud.getAttribute('data-target'):0;
  if(shud){window.ScrollTrigger.create({start:0,end:'max',scrub:.4,onUpdate:function(st){
    var p=st.progress;bar.style.transform='scaleX('+p+')';num.textContent=fmt(target*p)+'/yr';}});}
  // gentle parallax on gauges & stmt
  gsap.utils.toArray('.gauge,.stmt').forEach(function(v){
    gsap.fromTo(v,{y:34},{y:-34,ease:'none',scrollTrigger:{trigger:v,start:'top bottom',end:'bottom top',scrub:.8}});
  });
}else{
  [].forEach.call(document.querySelectorAll('[data-rv],[data-stagger]>*'),function(el){el.style.opacity=1;el.style.transform='none';});
}

/* ---------- magnetic buttons ---------- */
if(!RM) [].forEach.call(document.querySelectorAll('.btn'),function(b){
  b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();
    b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.28)+'px,'+((e.clientY-r.top-r.height/2)*.4)+'px)';});
  b.addEventListener('mouseleave',function(){b.style.transform='';});
});

/* ---------- spec spotlight ---------- */
[].forEach.call(document.querySelectorAll('.spec'),function(c){
  c.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();
    c.style.setProperty('--mx',(e.clientX-r.left)+'px');c.style.setProperty('--my',(e.clientY-r.top)+'px');});
});

/* ---------- FAQ ---------- */
[].forEach.call(document.querySelectorAll('.faq__q'),function(q){
  q.addEventListener('click',function(){
    var it=q.parentElement,a=it.querySelector('.faq__a'),open=it.classList.contains('open');
    [].forEach.call(document.querySelectorAll('.faq__i.open'),function(o){o.classList.remove('open');o.querySelector('.faq__a').style.maxHeight=null;});
    if(!open){it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  });
});

/* ---------- nav solid + burger ---------- */
(function(){
  var nav=document.querySelector('.nav');
  function onS(){if(window.scrollY>40)nav.classList.add('solid');else nav.classList.remove('solid');}
  onS();addEventListener('scroll',onS,{passive:true});
  var burger=document.querySelector('.burger'),panel=document.querySelector('.nav__l');
  if(burger){burger.addEventListener('click',function(){
    var open=panel.classList.toggle('open');burger.setAttribute('aria-expanded',open);});
    [].forEach.call(panel.querySelectorAll('a'),function(a){a.addEventListener('click',function(){
      panel.classList.remove('open');burger.setAttribute('aria-expanded','false');});});
  }
})();

/* ---------- modal ---------- */
(function(){
  var modal=document.getElementById('modal'); if(!modal) return;
  var sel=modal.querySelector('select[name="contact[service]"]');
  function open(svc){
    modal.classList.add('open');document.body.style.overflow='hidden';
    if(svc&&sel){for(var i=0;i<sel.options.length;i++)if(sel.options[i].value===svc){sel.selectedIndex=i;break;}}
  }
  function close(){modal.classList.remove('open');document.body.style.overflow='';}
  [].forEach.call(document.querySelectorAll('[data-book]'),function(b){
    b.addEventListener('click',function(e){e.preventDefault();open(b.getAttribute('data-service'));});
  });
  [].forEach.call(modal.querySelectorAll('[data-close]'),function(c){c.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  window.__fenlyxOpenModal=open;
})();
})();

(function(){if((window.__qok||window.__qerr)&&location.pathname.indexOf('/pages/contact')===-1){var m=document.getElementById('modal');if(m){m.classList.add('open');document.body.style.overflow='hidden';}}})();